const ADMIN_REVIEWER_KEY = 'hcen_admin_reviewer_name';

export function getAdminReviewerName() {
  try {
    return (localStorage.getItem(ADMIN_REVIEWER_KEY) || '').trim();
  } catch (_) {
    return '';
  }
}

export function setAdminReviewerName(name) {
  const v = String(name || '').trim();
  if (!v) return;
  try {
    localStorage.setItem(ADMIN_REVIEWER_KEY, v);
  } catch (_) { /* ignore */ }
}

export function ensureAdminReviewerName(currentName, toast) {
  const name = String(currentName || getAdminReviewerName() || '').trim();
  if (!name) {
    toast?.('Enter your name before this action — it is recorded permanently on the application.', true);
    return null;
  }
  setAdminReviewerName(name);
  return name;
}
